/** Set VITE_BONUSES_ENABLED=false and rebuild to suspend bonus login. */
export const bonusesEnabled = import.meta.env.VITE_BONUSES_ENABLED !== 'false'
